import React, { useState } from 'react';
import GameTable from './components/GameTable';
import UserSelector from './components/UserSelector';
import { User, users } from './types';
import './App.css';

function App() {
  const [selectedUser, setSelectedUser] = useState<User>(users[0]); // Ali Hamdi varsayılan

  const handleUserChange = (user: User) => {
    setSelectedUser(user);
  };

  return (
    <div className="App">
      <UserSelector 
        selectedUser={selectedUser} 
        onUserChange={handleUserChange} 
      />
      <GameTable selectedUser={selectedUser} />
    </div>
  );
}

export default App;
